import React from "react";

import styles from "./addedBy.module.scss";

/**
 * "Added by" cell for the content list pages.
 *
 * Reads the `createdBy` / `updatedBy` stamps the backend writes on create and
 * update. Only the last editor is shown, and only when it differs from the
 * creator — otherwise every row would repeat the same name twice.
 *
 * Content created before attribution existed has neither stamp; it renders a
 * dash rather than guessing, because attributing it to whoever happens to be
 * looking would be worse than admitting we don't know.
 */
const AddedBy = ({ record }) => {
    const createdBy = record?.createdBy?.adminName;
    const updatedBy = record?.updatedBy?.adminName;

    if (!createdBy && !updatedBy) {
        return <span className={styles.none} title="Added before activity tracking">—</span>;
    }

    const editedByOther = updatedBy && updatedBy !== createdBy;

    return (
        <div className={styles.wrap}>
            <span className={styles.name}>{createdBy || "—"}</span>
            {editedByOther && (
                <span className={styles.editor}>edited by {updatedBy}</span>
            )}
        </div>
    );
};

export default AddedBy;
